import React, { useState } from "react";

type CountryProps = {
	className?: string;
	flagCode?: string;
	hasOpponent?: boolean;
};

export default function CountryIcon(props: CountryProps) {
	const { className, flagCode, hasOpponent } = props;

	const [imageError, setImageError] = useState<boolean>(false);

	if ((!flagCode && !hasOpponent) || imageError) {
		return null;
	}

	if (!flagCode && hasOpponent) {
		return <span className={className ? className : "u-icon--med"}></span>;
	}

	return (
		<img
			className={className ? className : "u-icon--med"}
			//@ts-expect-error
			loading="lazy"
			src={getCountryIconUrl(flagCode)}
			onError={() => {
				setImageError(true);
			}}
		/>
	);
}

function getCountryIconUrl(flagCode: string | undefined) {
	return `${WEBPACK_CDN_ROOT_URL}/icons/countries/${flagCode?.toLowerCase()}.svg`;
}
